
// src/App.js
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Register from './pages/Register';

// Components

import CardPage from './pages/CardPage';
import ErrorBoundary from './components/error/ErrorBoundary';
import LoadingSpinner from './components/ui/LoadingSpinner';

const NotFound = React.lazy(() => import('./pages/NotFound'));

// Lazy load admin app
const AdminApp = React.lazy(() => import('./admin/AdminApp'));

// Loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-lightBgFrom via-lightBgVia to-lightBgTo dark:from-darkBgFrom dark:via-darkBgVia dark:to-darkBgTo">
    <LoadingSpinner size="lg" text="Loading page..." />
  </div>
);

// Public Routes Component
const PublicRoutes = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/:username" element={<CardPage />} />
          </Routes>
        </Suspense>
      </main>
    </div>
  );
};

export default function App() {
  return (
    <ErrorBoundary>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          {/* Admin Routes - No Navbar/Footer */}
          <Route path="/admin/*" element={<AdminApp />} />
          
          {/* Public Routes - With Navbar/Footer */}
          <Route path="/*" element={<PublicRoutes />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}
